import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Credentials|Logic|Copy Logic|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Credential,
	portal: 'SP',
};

type LocNameStart = 'SPCatalogCertCopyLogic';
export type SPCatalogCertCopyLogicLocNames =
	| `${LocNameStart}ButtonCopyLogic`
	| `${LocNameStart}NotificationLogicCopied`
	| `${LocNameStart}NotificationLogicCopyError`
	| `${LocNameStart}ContentInitialRequirement`
	| `${LocNameStart}ContentExtension`;

export const spCatalogCertCopyLogicLocs: LocDefs<SPCatalogCertCopyLogicLocNames> = {
	SPCatalogCertCopyLogicButtonCopyLogic: {
		defaultValue: 'Copy Logic',
		description: 'Copy Logic button',
		displayPath: `${pathStart}Copy Logic`,
		displayType: 'Button',
		legacyName: 'Credential/CatalogsCredential.Logic.Button.CopyLogic',
		...sharedProperties,
	},
	SPCatalogCertCopyLogicNotificationLogicCopied: {
		defaultValue: 'Logic copied',
		description: 'Notification message when logic is copied',
		displayPath: `${pathStart}Logic copied`,
		displayType: 'Notification',
		legacyName: 'Credential/CatalogsCredential.Logic.NotificationMessage.LogicCopied',
		...sharedProperties,
	},
	SPCatalogCertCopyLogicNotificationLogicCopyError: {
		defaultValue: 'There was an error copying the logic',
		description: 'Notification message when logic copy errors',
		displayPath: `${pathStart}Logic copy error`,
		displayType: 'Notification',
		legacyName: 'Credential/CatalogsCredential.Logic.NotificationMessage.CopyError',
		...sharedProperties,
	},
	SPCatalogCertCopyLogicContentInitialRequirement: {
		defaultValue: 'Initial Requirement',
		description: 'Content for initial requirement',
		displayPath: `${pathStart}Initial Requirement`,
		displayType: 'Content',
		legacyName: 'Credential/CatalogsCredential.Logic.MenuItem.InitialRequirement',
		...sharedProperties,
	},
	SPCatalogCertCopyLogicContentExtension: {
		defaultValue: 'Extension (Re-certification)',
		description: 'Content for Extension (Re-certification)',
		displayPath: `${pathStart}Extension (Re-certification)`,
		displayType: 'Content',
		legacyName: 'Credential/CatalogsCredential.Logic.MenuItem.Extension',
		...sharedProperties,
	},
};

export type SPCatalogCertCopyLogicLocType = LocMap<SPCatalogCertCopyLogicLocNames>;
